import { Injectable, Inject, Optional } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

export enum ZonarUiTestingTokens {
  CONTAINER_ID = 'googleOptimizeContainerId'
}

@Injectable({
  providedIn: 'any'
})
export class ABTestService {
  private readonly gOptId: string;
  private GoCookie = '_gaexp';
  private browserGlobals = {
    documentRef(): any {
      return document;
    }
  };

  constructor(
    @Optional() @Inject(ZonarUiTestingTokens.CONTAINER_ID) public googleOptimizeContainerId: string,
    private cookieService: CookieService
  ) {
    this.gOptId = googleOptimizeContainerId;
  }

  /**
   * Adds Google Optimize to DOM
   */
  public addTestingToDom() {
    if (this.gOptId) {
      const doc = this.browserGlobals.documentRef() as Document;
      const goScript = doc.createElement('script');
      goScript.id = 'GOScript';
      // @ts-ignore
      goScript.src = `https://www.googleoptimize.com/optimize.js?id=${this.gOptId}`;
      doc.head.insertBefore(goScript, doc.head.firstChild);
    }
  }

  /**
   * Returns an array of objects representing active experiments
   */
  public getExperiments() {
    /*
     * Google Optimize adds a cookie to the app. For a single running experiment the cookie looks like
     *
     *   GAX1.2.wyiyKiJeRBq2Bsrz00MeXw.19077.0-1
     *
     * Multiple simultaneous experiments result in this sort of cookie:
     *
     *   GAX1.2.rBdiWZ0EQlmzN0N7OzvkKQ.19077.1!N4wLulR9T6S3PUj1Rfd6Yg.19078.1-1
     */
    if (!this.cookieService.check(this.GoCookie)) {
      return null;
    }

    const experiments = [];
    const allCookies = this.cookieService.get(this.GoCookie).split('!');
    const cookies = allCookies.map((c, i) => {
      if (i > 0) {
        return c;
      }
      return c.split('.').slice(2).join('.');
    });
    for (const e of cookies) {
      const gaexp = e;
      const parts = gaexp.split('.');
      if (parts.length === 0) {
        experiments.push(null);
        break;
      }
      const suffix = parts[parts.length - 1];
      const id = parts[0];
      const validSuffix = new RegExp(/^[0-9](-[0-9])*$/).test(suffix);
      if (!validSuffix) {
        experiments.push(null);
        break;
      }
      const variants = suffix.split('-').map(Number);
      const variantObj = {
        id,
        tag: `${id}.${suffix}`,
        variants
      };

      experiments.push(variantObj);
    }
    return experiments;
  }
}
